import { RecipientType } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/recipient.types';
import { TFunction } from 'i18next';
import { z } from 'zod';

export const getNewMessageSchema = (t: TFunction, isReply = false) =>
  z
    .object({
      recipients: z.nativeEnum(RecipientType).optional(),
      subject: z.string().min(1, t('common.validation.fieldRequired')),
      messageText: z.string().min(1, t('common.validation.fieldRequired')),
      messageHtml: z.string().min(1, t('common.validation.fieldRequired')),
      file: z.any().optional(),
      attachment: z.string().optional(),
      fleets: z
        .array(
          z.object({
            fleet: z.string(),
            subFleet: z.string(),
          }),
        )
        .optional(),
      numberPlates: z.array(z.string()).optional(),
      scs: z
        .array(
          z.object({
            payrollNumber: z.string(),
            name: z.string(),
            surname: z.string(),
          }),
        )
        .optional(),
      gsc: z.array(z.string()).optional(),
      initDate: z.date().optional(),
      endDate: z.date().optional(),
    })
    .superRefine((data, ctx) => {
      const { recipients, initDate, endDate, numberPlates } = data;

      if (isReply) {
        return;
      }

      if (!recipients) {
        ctx.addIssue({
          path: ['recipients'],
          code: z.ZodIssueCode.custom,
          message: t('common.validation.fieldRequired'),
        });
        return;
      }

      if (recipients === RecipientType.SUBFLEET || recipients === RecipientType.PLATE) {
        if (!initDate) {
          ctx.addIssue({
            path: ['initDate'],
            code: z.ZodIssueCode.custom,
            message: t('common.validation.fieldRequired'),
          });
        }

        if (!endDate) {
          ctx.addIssue({
            path: ['endDate'],
            code: z.ZodIssueCode.custom,
            message: t('common.validation.fieldRequired'),
          });
        }
      }

      if (recipients === RecipientType.PLATE && (!numberPlates || numberPlates.length === 0)) {
        ctx.addIssue({
          path: ['numberPlates'],
          code: z.ZodIssueCode.custom,
          message: t('common.validation.fieldRequired'),
        });
      }
    });
